import { Validator } from 'vee-validate';

Validator.extend('required', {
  getMessage: () => 'Campo requerido',
  validate: value => !!value
});

Validator.extend('email', {
  getMessage: () => 'Email inválido',
  validate: value => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return regex.test(value);
  }
});